module.exports = __webpack_public_path__ + "img/pending-invites-136px.d100e21.png";